import { AxiosInstance } from 'axios'

export type UploadUserProfileImageParams = {
  userId: string
  picture: File
}

type UploadUserProfileImage = (
  apiClient: AxiosInstance,
  params: UploadUserProfileImageParams
) => Promise<string>

export const uploadUserProfileImage: UploadUserProfileImage = async (
  apiClient,
  { userId, picture }
) => {
  const formData = new FormData()
  formData.append('picture', picture)

  const { data } = await apiClient.post(
    `/api/users/${userId}/picture`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )

  return data.data
}
